import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Tooltip, Icon } from 'antd'

export class Helper extends Component {


  render() {
    const { content, intl, color } = this.props


    return (
      <Tooltip
        placement="top"
        title={intl.formatMessage({ id: content })}>
        <Icon type="question-circle" style={{ margin: 10, color: color }} />
      </Tooltip>
      // <Popover
      //   content={intl.formatMessage({ id: content })}
      //   title={intl.formatMessage({ id: title })}
      //   trigger={trigger}>
      //   <Icon type="question-circle" style={{ color: '#3E91F7' }} />
      // </Popover>
    )
  }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Helper)))